import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'involvement',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './involvement.component.html',
  styleUrl: './involvement.component.css'
})
export class InvolvementComponent implements OnInit, OnChanges {

  @Input() witnessInterviewData: any = {};
  @Output() onSaveSection2 = new EventEmitter<any>();

  yesNo = EYesNo;
  involvementForm: FormGroup = new FormGroup([]);

  radioQuestions = [
    {
      id: 'witness_threat',
      questionText: "Did you witness the threat or situation? *",
      formControlName: 'witness_threat'
    },
    {
      id: 'threat_target',
      questionText: "Were you the recipient or target of the threat? *",
      formControlName: 'threat_target'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['witnessInterviewData'] && this.witnessInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.witnessInterviewData && this.witnessInterviewData[question.formControlName] !== undefined
                           ? this.witnessInterviewData[question.formControlName]
                           : this.yesNo.No;  

      group[question.formControlName] = new FormControl(
          String(defaultValue), 
          Validators.required
      );
    });
    
    this.involvementForm = new FormGroup(group);
  }

  saveInvolvement(): void {
    if (this.involvementForm.valid) {
      this.onSaveSection2.emit(this.involvementForm.value);
    }
  }

}
